<template>
    <div class="min-h-[70vh] flex " v-if="getLoadingNotification">
        <SpinnerComponent class="m-auto" />
    </div>
    <section v-else>
		<table class="min-w-full  divide-y divide-gray-200">
		<tbody class="bg-white divide-y divide-gray-200 border-t">
      <tr v-if="!getNotifications || getNotifications.length == 0" class="text font-bold m-auto text-gray-500">
          <td class="whitespace-no-wrap py-12 text-center text-gray-500">    
              Nenhum resultado encontrado
              <p class="text-sm font-normal py-2">Experimente utilizar diferentes filtros para a sua pesquisa..</p>
          </td>
      </tr>
			<tr @click="clickNotification(notification)" v-for="(notification ,index) in getNotifications" :key="index" 
				:class="{ 
          'bg-blue-50 dark:bg-stone-700': notification.Users[0].Users_Notifications.visualizado == 'N',
          'cursor-pointer' : notification.link
        }" 
				class="transition-all hover:bg-gray-100 text-sm text-gray-600">
				<td v-if="notification.components?.length ? notification.components : mountComponentsFromNotification(notification)" class="whitespace-no-wrap flex justify-center p-4">
					<div v-if="notification.components.find(c => c.type === 'header')" class="flex rounded">
						<img class="w-10 h-10 border-2 rounded" v-for="(param, index) in notification.components.find(c => c.type === 'header')?.parameters" :key="'img-'+index" :src="param.image?.link" />
                    </div>
					<div v-else class="flex p-2 bg-blue-100 rounded">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 text-[#008CD7]"><path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" /></svg>
					</div>
				</td>
				<td class="whitespace-no-wrap p-4 text-sm text-gray-600">
					<h3 class="text-lg font-medium text-gray-900 dark:text-white">{{ notification.titulo }}</h3>
					<!-- BODY - Texto -->
					<p v-if="notification.components.find(c => c.type === 'body')" class="text-sm font-normal text-gray-700 mb-2">
					{{ getFormattedMessage(notification.templateName, notification.components) }}
					</p>
					<div class="flex items-center gap-2 flex-wrap">
						<div class="flex items-center gap-1 whitespace-nowrap text-gray-400 dark:text-gray-400">
							<svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
							<p class="text-xs font-medium">{{ new Date(notification.createdAt).toLocaleString('pt-BR', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'}) }}</p>
						</div>
					</div>
				</td>
        <td class="p-2">
          <span v-if="notification.link" class="inline-flex items-center gap-1 text-xs font-medium text-indigo-600 dark:text-indigo-400" title="Clique na notificação para abrir o link">
            <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" /></svg>
          </span>
        </td>
			</tr>
		</tbody>
		</table>
        <div v-if="$store.state.notifications.page < $store.state.notifications.pages" class="space-y-4 text-center my-3">
          <button @click="moreNotificationsUser({pageNumber: $store.state.notifications.page + 1})" class="inline-block text-sm text-gray-600 transition bg-transparent hover:text-gray-400">
              Ver mais &nbsp;&rarr;
          </button>
        </div>
    </section>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import SpinnerComponent from '@/components/helper/SpinnerComponent.vue';

  export default {
    name: 'NotificationComponent',
    components: {
        SpinnerComponent
    },
    methods: {
		...mapActions(['notificationsUser', 'updateNotification', 'moreNotificationsUser', 'fetchMessage_Templates', 'notificationQntPendente']),

		async clickNotification(notification){
      console.log(notification.Users[0].Users_Notifications)
			if(notification.Users[0].Users_Notifications.visualizado == 'N') await this.updateNotification({ idNotification: notification.id });

			const hasButton = notification.components && notification.components.find(c => c.type === 'button');
			if (hasButton) {
				const urls = this.getFormattedButtonLinks(notification.templateName, notification.components);
				const url = Array.isArray(urls) ? urls[0] : urls;
				if (url) window.open(url, '_blank');
				this.notificationQntPendente();
			} else if (notification.link) {
				this.notificationQntPendente();
				window.open(notification.link);
			}
		},
      getFormattedMessage(templateName, components) {
        const template = this.getMessage_Templates.find(t => t.name === templateName);

        if (!template || !template.components) {
            const bodyComponent = components?.find(c => c.type === 'body');
            const textParam = bodyComponent?.parameters?.[0]?.text;
            return textParam || null;
        }

        const bodyComponent = template.components.find(c => c.type === 'BODY');
        if (!bodyComponent) {
            const fallbackBody = components?.find(c => c.type === 'body');
            const fallbackText = fallbackBody?.parameters?.[0]?.text;
            return fallbackText || null;
        }

        let messageText = bodyComponent.text;

        // Substitui {{1}}, {{2}}, ... com os parâmetros
        components?.forEach(component => {
            if (component.type === 'body') {
                component.parameters?.forEach((param, index) => {
                    const placeholder = `{{${index + 1}}}`;
                    messageText = messageText.replace(placeholder, param.text);
                });
            }
        });

        return messageText;
    },
    getFormattedButtonLinks(templateName, components) {
        const template = this.getMessage_Templates.find(t => t.name === templateName);

        if (!template || !template.components) return [];

        const buttonComponent = template.components.find(c => c.type === 'BUTTONS');
        const actualButtonComponent = components?.find(c => c.type === 'button');

        if (!buttonComponent || !actualButtonComponent) return [];

        return buttonComponent.buttons.map((btn) => {
            let url = btn.url;

            actualButtonComponent.parameters?.forEach((param, index) => {
                const placeholder = `{{${index + 1}}}`;
                url = url.replace(placeholder, param.text);
            });
            return url;
        });
      },
      async mountComponentsFromNotification(data) {
        if (!data?.Users_Notifications) {
          throw new Error("Dados insuficientes para montar a mensagem.");
        }

        if (!data?.descricao) {
            throw new Error("Descrição da notificação ausente.");
        }

        // Descrição do template (com placeholders {{1}}, {{2}}, ...)
        let descricao = data.descricao;
        const parametros = JSON.parse(data.Users_Notifications[0].variaveis || "[]");

        if(data.variaveis){
          // Substitui os placeholders {{1}}, {{2}}, ... pelos valores reais
          descricao = descricao.replace(/\{\{(\d+)\}\}/g, (_, index) => {
              return parametros[index - 1]?.text?.trim() || `{{${index}}}`;
          });
        }
        // Remove múltiplos espaços consecutivos e caracteres indesejados
        descricao = descricao.replace(/\s{2,}/g, " "); // Substitui 2+ espaços por um único espaço
        descricao = descricao.replace(/[\t\n\r]/g, " "); // Remove tabulações e quebras de linha

        let formattedMedia = null;
        let formattedButtons = [];

        if(data.mediaUrl){
          formattedMedia = {
            type: "header",
            parameters: [
              {
                type: "image",
                image: { link: data.mediaUrl }
              }
            ]
          };
        }
        if(data.buttons && data.buttons.length){
          formattedButtons = data.buttons.map((button, index) => ({
            type: "button",
            sub_type: button.type,
            index: index,
            parameters: [{ type: "text", text: button.text }]
          }));
        }

        const components = [];

        components.push({
          type: "body",
          parameters: [{ type: "text", text: descricao }]
        });
        
        if (formattedMedia) components.push(formattedMedia);
        if (formattedButtons.length) components.push(...formattedButtons);

        data.components = components;
      }
    },
    mounted(){
      this.notificationsUser();
      if (typeof this.getMessage_Templates === 'undefined' || !this.getMessage_Templates.length) {
        this.fetchMessage_Templates();
      }
    },
    computed: {
      ...mapGetters(['getNotifications', 'getLoadingNotification', 'getMessage_Templates']),
    }
  }
</script>
